// Single source of truth for OSCE Socket.IO room names.
export const channels = {
  examLive: () => "exam:live",
};
